import { useTheme as muiUseTheme } from '@mui/private-theming';

function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}

function useTheme(defaultTheme = null) {
  const contextTheme = muiUseTheme();
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}

export default useTheme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/system/esm/useThemeWithoutDefault.js
// module id = 1111
// module chunks = 0